<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <section class="content-header">
        <el-button
          type="primary"
          icon="el-icon-plus"
          class="float-right"
          @click="handleAdd"
        >Add</el-button>
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li class="active">
            <router-link :to="{name:'users'}">
              Users
            </router-link>
          </li>

        </ol>
      </section>
      <!-- Main content -->
      <section class="content user-content">
        <!-- Basic Tables-->
        <div
          class="box"
          v-loading="loading"
        >
          <div class="box-body">
            <el-table
              :data="list"
              style="width: 100%"
            >
              <template slot="empty">
                Loading...
              </template>

              <el-table-column
                prop="name"
                label="Name"
              >
              </el-table-column>

              <el-table-column
                prop="email"
                label="Email"
              >
              </el-table-column>

              <el-table-column
                prop="role"
                label="Role"
              >
              </el-table-column>

              <el-table-column
                prop="created"
                label="Created"
              >
              </el-table-column>

              <el-table-column
                prop="updated"
                label="Updated"
              >
              </el-table-column>
             <el-table-column align="right">
                <template scope="scope">
                  <el-row>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="View"
                      placement="top-start"
                    >
                      <el-button
                        type="success"
                        icon="el-icon-view"
                        circle
                        class="btn-rounded"
                        @click="handleView(scope.row)"
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="Edit"
                      placement="top-start"
                    >
                      <el-button
                        type="primary"
                        icon="el-icon-edit"
                        circle
                        class="btn-rounded"
                        @click="handleEdit(scope.row)"
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="Delete"
                      placement="top-start"
                    >
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        class="btn-rounded"
                        @click="handleDelete(scope.row)"
                      ></el-button>
                    </el-tooltip>
                  </el-row>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="box-footer">
            <el-pagination
              background
              :page-size="pagination.pageSize"
              layout="prev, pager, next, sizes"
              :total="pagination.totalCount"
              :page-sizes="pagination.rowsPerPageItems"
              :current-page="pagination.pageNum"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'users',
  data: function () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('users', ['list']),
    pagination: {
      get: function () {
        return this.$store.getters['users/pagination']
      },
      set: function (value) {
        this.$store.commit('users/setPagination', value)
      }
    }
  },
  watch: {
    pagination: {
      handler () {
        this.loading = true
        this.fetchUsers()
          .then(_ => {
            this.loading = false
          })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('users', ['fetchUsers', 'deleteUser']),
    handleEdit (row) {
      this.$router.push({ name: 'editUser', params: { id: row.id } })
    },
    handleView (row) {
      this.$router.push({ name: 'viewUser', params: { id: row.id } })
    },
    handleDelete (row) {
      this.$confirm('This will delete customer. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.deleteUser({ id: row.id })
            .then(_ => this.fetchUsers())
            .then(_ =>
              this.$message({
                type: 'success',
                message: 'Delete completed'
              }))
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          })
        })
    },
    handleAdd () {
      this.$router.push({ name: 'addUser' })
    },
    handleSizeChange (pageSize) {
      this.pagination = { ...this.pagination, pageSize }
    },
    handleCurrentChange (pageNum) {
      this.pagination = { ...this.pagination, pageNum }
    }
  },
  created () {
    this.fetchUsers()
  }

}
</script>



// WEBPACK FOOTER //
// Index.vue?fe70157e